// import React, { useEffect ,useState} from "react";
const ListView = ({
  width = "100%",
  height = "90%",
  header = [],
  records = [],
  onedit,
  onview,
  ondelete,
  onSelect,
  selected = [],
  onclick,
  Tablehead = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[16px] xl:text-[20px] font-bold ",
  Tablerecord = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[12px] xl:text-[16px] overflow-hidden",
}) => {
  // const [filters, setFilters] = useState({});
  // const [sortConfig, setSortConfig] = useState({
  //   field: "",
  //   direction: "asc",
  // });

  // const handleSort = (label) => {
  //   setSortConfig((prev) => ({
  //     field: label,
  //     direction:
  //       prev.field === label && prev.direction === "asc" ? "desc" : "asc",
  //   }));
  // };

  //   const filteredRecords = records
  //   .filter((record) =>
  //     header.every(([_, label]) => {
  //       const filterValue = filters[label];
  //       if (!filterValue) return true;

  //       let fieldValue = record[label];
  //       if (label.toLowerCase().includes("date") && fieldValue) {
  //         const parsed = new Date(fieldValue);
  //         if (!isNaN(parsed)) fieldValue = parsed.toISOString().split("T")[0];
  //       }
  //       return (
  //         fieldValue &&
  //         fieldValue.toString().toLowerCase().includes(filterValue.toLowerCase())
  //       );
  //     })
  //   )
  //   .sort((a, b) => {
  //     const { field, direction } = sortConfig;
  //     if (!field) return 0;

  //     const aVal = (a[field] ?? "").toString().toLowerCase();
  //     const bVal = (b[field] ?? "").toString().toLowerCase();

  //     if (aVal < bVal) return direction === "asc" ? -1 : 1;
  //     if (aVal > bVal) return direction === "asc" ? 1 : -1;
  //     return 0;
  //   });

  return (
    <div
      className={`flex  overflow-auto `}
      style={{ height: height, width: width }}
    >
      <div className="origin-top-left scale-[0.8] min-w-[125%]">
        <table className="table-auto w-full h-fit">
          <thead className="sticky top-0 bg-secondary text-left mt-10 border-b">
            <tr className="px-1">
              {/* <th className={Tablehead}>S.No.</th> */}
              {header.map(([name, label], index) => {
                if (label !== "id" && label !== "ACTION") {
                  return (
                    <th key={index} className={Tablehead}>
                      {name}
                      {/* <div
                      className="flex flex-col cursor-pointer"
                      onClick={() => handleSort(label)}
                    >
                      <div className="flex items-center justify-between">
                        <span>{name}</span>
                        {sortConfig.field === label && (
                          <span>{sortConfig.direction === "asc" ? "↑" : "↓"}</span>
                        )}
                      </div>
                      <input
                        type={label.toLowerCase().includes("date") ? "date" : "text"}
                        placeholder={`Filter ${name}`}
                        className="px-1 mt-1 rounded-sm text-sm"
                        value={filters[label] || ""}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            [label]: e.target.value,
                          }))
                        }
                      />
                    </div> */}
                    </th>
                  );
                } else if (label === "ACTION" && (onedit || onview || ondelete)) {
                  return (
                    <th key={index} className={Tablehead}>
                      {name}
                    </th>
                  );
                }
              })}
            </tr>
          </thead>


          <tbody>
            {records.map((item, index) => (
              // {filteredRecords.map((item, index) => (

              <tr
                key={index}
                className={
                  "border-b h-8 hover:bg-[#b3b3f5] rounded-xl cursor-pointer " +
                  (item?.error && ` bg-red bg-opacity-35 `)
                }
              >
                {/* <td className={Tablerecord}>{index + 1}</td> */}

                {header.map(([name, label], fieldindex) => {
                  // console.log("Listview actioon",field == "ACTION" && (ondelete!=undefined||onview!=undefined||onedit!=undefined),(ondelete!=undefined||onview!=undefined||onedit!=undefined));

                  if (label == "ACTION") {
                    if (onedit || onview || ondelete) {
                      return (
                        <td key={fieldindex} className={Tablerecord}>
                          <div className="flex gap-7">
                            {onedit && (
                              <img
                                src="/Assets/images/pencil.png"
                                className=" cursor-pointer w-5 h-5 hover:scale-125"
                                onClick={() => {
                                  onedit(item);
                                }}
                              />
                            )}
                            {onview && (
                              <img
                                src="/Assets/images/eye.png "
                                className=" cursor-pointer w-5 h-5 hover:scale-125"
                                onClick={() => {
                                  onview(item);
                                }}
                              />
                            )}
                            {ondelete && (
                              <img
                                src="/Assets/images/trash.png"
                                className=" cursor-pointer w-5 h-5 hover:scale-125"
                                onClick={() => {
                                  const confirmDelete = window.confirm(
                                    "Are you sure you want to delete?"
                                  );
                                  if (confirmDelete) {
                                    ondelete(item);
                                  }
                                }}
                              />
                            )}
                          </div>
                        </td>
                      );
                    }
                  } else if (label == "select") {
                    return (
                      <td
                        key={fieldindex}
                        className={
                          Tablerecord +
                          " hover:bg-red flex justify-center items-center h-full"
                        }
                      >
                        <input
                          type={"checkbox"}
                          onChange={(event) => {
                            onSelect && onSelect(item, event.target.checked);
                          }}
                          checked={
                            selected.filter((selected) => selected.id == item.id)
                              .length > 0
                          }
                        />
                      </td>
                    );
                  } else if (label === "activeStatus") {
                    return (
                      <td key={fieldindex} className={Tablerecord}>
                        {item[label] ? "Active" : "Inactive"}
                      </td>
                    );
                  } else if (
                    label.toLowerCase().includes("date") &&
                    item[label] != undefined
                  ) {
                    const [date, time] = item[label].split("T");
                    if (time != null && time != undefined) {
                      // console.log("Time ", date, time);

                      return (
                        <td
                          key={fieldindex}
                          className={Tablerecord}
                          onClick={() => {
                            onclick && onclick(item);
                          }}
                        >
                          {date}
                        </td>
                      );
                    } else if (date != null && date != undefined) {
                      // console.log("Time ", date, time);

                      return (
                        <td
                          key={fieldindex}
                          className={Tablerecord}
                          onClick={() => {
                            onclick && onclick(item);
                          }}
                        >
                          {date}
                        </td>
                      );
                    } else {
                      return (
                        <td key={fieldindex} className={Tablerecord}>
                          ---
                        </td>
                      );
                    }
                  } else if (label != "id") {
                    return (
                      <td
                        key={fieldindex}
                        className={Tablerecord}
                        onClick={() => {
                          onclick && onclick(item);
                        }}
                      >
                        {item[label]?.toString()?.charAt(0)?.toUpperCase() +
                          item[label]?.toString()?.slice(1)}
                      </td>
                    );
                  } else {
                    <td key={fieldindex} className={Tablerecord}>
                      ---
                    </td>;
                  }
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListView;
